
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/set-update",
      function () {
        return require("private-next-pages/info/set-update.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/set-update"])
      });
    }
  